<template lang="pug">
div._root(style='min-height: calc(99vh - var(--footer-height, 0));')
    router-view

Footer
</template>

<script setup>
import { useRoute } from "vue-router";
import Footer from "@/components/footer.vue";

const route = useRoute();
</script>
<style lang="less">
@import "@/assets/less/bq-tokens.less";

.service-swiper {

    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-horizontal>.swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal {
        bottom: 1.25rem;
        top: initial;
        left: 1.5625rem;
        width: fit-content;
    }

    .swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 0 0.1875rem;
    }

    .swiper-pagination-bullet {
        opacity: 0.3;
        width: 0.5rem;
        height: 0.5rem;
    }

    .swiper-pagination-bullet-active {
        opacity: 0.8 !important;
        background: @ink;
    }
}

.review-swiper {
    .swiper {
        padding-bottom: 8rem;
    }

    .swiper-pagination {
        width: unset !important;
        bottom: unset !important;
        top: 39.5rem !important;
    }

    .swiper-pagination-bullet {
        width: 11px;
        height: 11px;
        background: @placeholder;
        margin: 0 5px !important;

        &:hover {
            background: @paper;
        }
    }

    .swiper-pagination-bullet-active {
        background: @paper;
    }
}
@media (max-width: 800px) {
    .review-swiper {
        .swiper {
            padding-bottom: 6rem;
        }

        .swiper-pagination {
            left: 50% !important;
            top: var(--swiper-pagination-translate-y, 0) !important;
            transform: translateX(-50%) !important;
        }

        .swiper-pagination-bullet {
            margin: 0 8px !important;
        }
    }
}

@media (max-width: 480px) {
    .review-swiper {
        .swiper {
            padding-bottom: 0;
        }
    }
}
</style>
